// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sugestions-block {
  border-radius: 4px;
  border: 1px solid var(--borderSuggestions);
  background: var(--AA-global-white-bg);
  display: flex;
  flex-direction: column;
}
.sugestions-block .suggestion-header {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  min-height: 32px;
  gap: 5px;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.sugestions-block .suggestion-header .icon_block {
  flex-shrink: 0;
  line-height: 0;
}
.sugestions-block .suggestion-header h1 {
  max-width: 100%;
}
.sugestions-block .suggestion-header .count-text {
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  padding: 0px 8px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--AA-global-theme-text-color);
}
.sugestions-block .suggestion-header .by-n-ai {
  display: flex;
  align-items: center;
  color: var(--AA-gloabl-text-desc-color);
  gap: 2px;
}
.sugestions-block .suggestion-header .by-n-ai svg {
  opacity: 0.5;
  width: 14px;
  height: 14px;
}
.sugestions-block .suggestion-header .by-n-ai svg path {
  fill: var(--AA-gloabl-text-color);
}
.sugestions-block .suggestion-header .by-n-ai i {
  opacity: 0.5;
}
.sugestions-block .suggestion-header .by-n-ai .snippet-by-label {
  color: var(--AA-gloabl-text-desc-color);
  font-style: italic;
}
.sugestions-block .suggestion-body-search {
  padding: 0px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.sugestions-block .suggestion-body-search .suggestion-item-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 8px 0;
  position: relative;
}
.sugestions-block .suggestion-body-search .suggestion-item-card:hover {
  transition: 0.2s all ease;
}
.sugestions-block .suggestion-body-search .suggestion-item-card:hover .suggestion-header-faq .action-buttons {
  display: flex;
}
.sugestions-block .suggestion-body-search .suggestion-item-card.hidden {
  display: none;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  transition: 0.2s all ease;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec .sent-msg-text {
  color: var(--AA-global-theme-text-color);
  margin: 0 0 0 auto;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec .up-down-arrows {
  flex-shrink: 0;
  cursor: pointer;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec .up-down-arrows svg {
  height: 14px;
  width: 14px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec .up-down-arrows svg path {
  fill: var(--AA-gloabl-text-color);
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .action-buttons {
  flex-shrink: 0;
  display: none;
  align-items: center;
  gap: 4px;
  position: absolute;
  right: 0;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .action-buttons .aa-copy-btn-suggestion svg path {
  stroke: var(--AA-gloabl-text-color);
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .action-buttons .aa-solidbtn {
  height: 24px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  transition: 0.2s all ease;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .suggestion-paragraph {
  transition: max-height 0.3s ease;
  overflow: hidden;
  max-height: 50px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .suggestion-paragraph.expanded {
  max-height: none; /* Show full content when expanded */
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .suggestion-paragraph.expanded + .aa-more-button {
  display: none; /* Hide button when expanded */
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .suggestion-paragraph:not(.expanded) + .aa-more-button {
  display: block; /* Show button when not expanded */
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq:hover .action-buttons {
  display: flex;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .action-buttons {
  flex-shrink: 0;
  display: none;
  align-items: center;
  gap: 4px;
  position: absolute;
  right: 0;
  z-index: 1;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .action-buttons .aa-solidbtn {
  height: 24px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .more-links-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .line-with-text-heading {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin: 6px 0;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .line-with-text-heading h2 {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
  flex-shrink: 0;
  color: #F04438;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .line-with-text-heading span {
  width: 100%;
  height: 1px;
  background: var(--AA-gloabl-border);
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper h1 {
  font-style: italic;
  flex-shrink: 0;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  overflow: hidden;
  flex-wrap: wrap;
  width: 100%;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag {
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  transition: 0.2s all ease;
  flex: 0 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag:hover span {
  opacity: 1;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag:hover a {
  text-decoration-line: underline;
  opacity: 1;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag span {
  display: flex;
  width: 14px;
  height: 14px;
  padding: 0;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--AA-global-white-bg);
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag a {
  overflow: hidden;
  color: var(--AA-gloabl-text-desc-color);
  text-align: center;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  opacity: 0.8;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .form-feedback-info {
  padding: 0;
  background: transparent;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .form-feedback-info .dialog-ended-and-feedback {
  justify-content: flex-end;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .icon_block {
  display: none;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info h1 {
  display: none;
}
.sugestions-block .suggestion-body-search .less-text.hidden {
  display: none;
}
.sugestions-block .suggestion-body-search .more-text.hidden {
  display: none;
}

.assist-suggestions-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
}
.assist-suggestions-list .sugestions-block {
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
}
.assist-suggestions-list .sugestions-block .suggestion-body-search {
  padding-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/scss/_search_suggestion.scss","webpack://./src/components/common/templatemanager/tabs/assist-suggestions/assist-suggestions.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,0CAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;ACCJ;ADAI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;ACER;ADDQ;EACI,cAAA;EACA,cAAA;ACGZ;ADDQ;EACI,eAAA;ACGZ;ADDQ;EACI,cAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;ACGZ;ADDQ;EACI,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,QAAA;ACGZ;ADFY;EACI,YAAA;EACA,WAAA;EACA,YAAA;ACIhB;ADHgB;EACI,iCAAA;ACKpB;ADFY;EACI,YAAA;ACIhB;ADFY;EACI,uCAAA;EACA,kBAAA;ACIhB;ADAI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;ACER;ADDQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;ACGZ;ADFY;EACI,yBAAA;ACIhB;ADFoB;EACI,aAAA;ACIxB;ADAY;EACI,aAAA;ACEhB;ADAY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;ACEhB;ADDgB;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;ACGpB;ADFoB;EACI,wCAAA;EACA,kBAAA;ACIxB;ADCoB;EACI,cAAA;EACA,eAAA;ACCxB;ADAwB;EACI,YAAA;EACA,WAAA;ACE5B;ADD4B;EACI,iCAAA;ACGhC;ADKgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;ACHpB;ADM4B;EACI,mCAAA;ACJhC;ADQoB;EACI,YAAA;ACNxB;ADUY;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;ACRhB;ADSgB;EACI,gCAAA;EACA,gBAAA;EACA,gBAAA;ACPpB;ADSgB;EACI,gBAAA,EAAA,oCAAA;ACPpB;ADSgB;EACI,aAAA,EAAA,8BAAA;ACPpB;ADUgB;EACI,cAAA,EAAA,kCAAA;ACRpB;ADWoB;EACI,aAAA;ACTxB;ADYgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;ACVpB;ADWoB;EACI,YAAA;ACTxB;ADYgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;ACVpB;ADYgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;ACVpB;ADWoB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;ACTxB;ADWoB;EACI,WAAA;EACA,WAAA;EACA,mCAAA;ACTxB;ADYgB;EACI,aAAA;EACA,uBAAA;EACA,QAAA;ACVpB;ADWoB;EACI,kBAAA;EACA,cAAA;ACTxB;ADWoB;EACI,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;ACTxB;ADUwB;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,yCAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;ACR5B;ADUgC;EACI,UAAA;ACRpC;ADUgC;EACI,+BAAA;EACA,UAAA;ACRpC;ADW4B;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,qCAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ACThC;ADW4B;EACI,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;ACThC;ADeY;EACI,UAAA;EACA,uBAAA;ACbhB;ADcgB;EACI,yBAAA;ACZpB;ADgBgC;EACI,aAAA;ACdpC;ADgBgC;EACI,aAAA;ACdpC;ADuBY;EACI,aAAA;ACrBhB;ADyBY;EACI,aAAA;ACvBhB;;AAxQA;EAEI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,YAAA;AAyQJ;AAxQI;EACI,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,qCAAA;AA0QR;AAzQQ;EACI,mBAAA;AA2QZ","sourcesContent":[".sugestions-block{\n    border-radius: 4px;\n    border: 1px solid var(--borderSuggestions);\n    background: var(--AA-global-white-bg);\n    display: flex;\n    flex-direction: column;\n    .suggestion-header{\n        display: flex;\n        align-items: center;\n        padding: 4px 8px;\n        min-height: 32px;\n        gap: 5px;\n        width: 100%;\n        overflow: hidden;\n        position: relative;\n        .icon_block{\n            flex-shrink: 0;\n            line-height: 0;\n        }\n        h1{\n            max-width: 100%;\n        }\n        .count-text{\n            flex-shrink: 0;\n            border-radius: 16px;\n            background: var(--AA-gloabl-bg-secondary);\n            padding: 0px 8px;\n            height: 15px;\n            display: flex;                   \n            justify-content: center;\n            align-items: center;\n            color: var(--AA-global-theme-text-color);\n        }\n        .by-n-ai{\n            display: flex;\n            align-items: center;\n            color: var(--AA-gloabl-text-desc-color);\n            gap: 2px;\n            svg{\n                opacity: 0.5;\n                width: 14px;\n                height: 14px;\n                path{\n                    fill: var(--AA-gloabl-text-color);\n                }\n            }\n            i{\n                opacity: 0.5;\n            }\n            .snippet-by-label{\n                color: var(--AA-gloabl-text-desc-color);\n                font-style: italic;\n            }\n        }\n    }\n    .suggestion-body-search{\n        padding: 0px 8px;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        width: 100%;\n        .suggestion-item-card{\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            width: 100%;\n            padding: 8px 0;\n            position: relative;\n            &:hover{\n                transition: 0.2s all ease;\n                .suggestion-header-faq{\n                    .action-buttons{\n                        display: flex;\n                    }\n                }\n            }\n            &.hidden {\n                display: none;\n            }\n            .suggestion-header-faq{\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                position: relative;\n                transition: 0.2s all ease;\n                .titles-info-sec{\n                    width: 100%;\n                    display: flex;\n                    align-items: center;\n                    gap: 4px;\n                    overflow: hidden;\n                    .sent-msg-text{\n                        color: var(--AA-global-theme-text-color);\n                        margin: 0 0 0 auto;\n                    }\n                    .child-bot-name{\n                       \n                    }\n                    .up-down-arrows{\n                        flex-shrink: 0;\n                        cursor: pointer;\n                        svg{\n                            height: 14px;\n                            width: 14px;\n                            path{\n                                fill: var(--AA-gloabl-text-color);\n                            }\n                        }\n                        &.aa-faq-up-arrow{\n                            \n                        }\n                    }\n                }\n                .action-buttons{\n                    flex-shrink: 0;\n                    display: none;\n                    align-items: center;\n                    gap: 4px;\n                    position: absolute;\n                    right: 0;\n                    .aa-copy-btn-suggestion{\n                        svg{\n                            path{\n                                stroke: var(--AA-gloabl-text-color);\n                            }\n                        }\n                    }\n                    .aa-solidbtn{\n                        height: 24px;\n                    }\n                }\n            }\n            .suggestion-body-faq{\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n                position: relative;\n                transition: 0.2s all ease;\n                .suggestion-paragraph{\n                    transition: max-height 0.3s ease; \n                    overflow: hidden;\n                    max-height: 50px;\n                }\n                .suggestion-paragraph.expanded {\n                    max-height: none; /* Show full content when expanded */\n                }\n                .suggestion-paragraph.expanded + .aa-more-button {\n                    display: none; /* Hide button when expanded */\n                }\n        \n                .suggestion-paragraph:not(.expanded) + .aa-more-button {\n                    display: block; /* Show button when not expanded */\n                }\n                &:hover{\n                    .action-buttons{\n                        display: flex;\n                    }\n                }\n                .action-buttons{\n                    flex-shrink: 0;\n                    display: none;\n                    align-items: center;\n                    gap: 4px;\n                    position: absolute;\n                    right: 0;\n                    z-index: 1;\n                    .aa-solidbtn{\n                        height: 24px;\n                    }\n                }\n                .more-links-buttons{\n                    display: flex;\n                    align-items: center;\n                    gap: 4px;\n                }\n                .line-with-text-heading{\n                    display: flex;\n                    align-items: center;\n                    gap: 6px;\n                    width: 100%;\n                    margin: 6px 0;\n                    h2{\n                        font-size: 12px;\n                        font-weight: 500;\n                        line-height: 18px;\n                        margin: 0;\n                        flex-shrink: 0;\n                        color: #F04438;\n                    }\n                    span{\n                        width: 100%;\n                        height: 1px;\n                        background: var(--AA-gloabl-border);\n                    }\n                }\n                .souces-names-wrapper{\n                    display: flex;\n                    align-items: flex-start;\n                    gap: 4px;\n                    h1{\n                        font-style: italic;\n                        flex-shrink: 0;\n                    }\n                    .source-names{\n                        display: flex;\n                        align-items: flex-start;\n                        gap: 8px;\n                        overflow: hidden;\n                        flex-wrap: wrap;\n                        width: 100%;\n                        .source-tag{\n                            display: flex;\n                            padding: 2px 8px;\n                            justify-content: center;\n                            align-items: center;\n                            gap: 4px;\n                            border-radius: 16px;\n                            background: var(--AA-gloabl-bg-secondary);\n                            transition: 0.2s all ease;\n                            flex : 0 auto;\n                            text-overflow: ellipsis;\n                            overflow: hidden;\n                            white-space: nowrap;\n                            &:hover{\n                                span{\n                                    opacity: 1;\n                                }\n                                a{\n                                    text-decoration-line: underline;\n                                    opacity: 1;\n                                }\n                            }\n                            span{\n                                display: flex;\n                                width: 14px;\n                                height: 14px;\n                                padding: 0;\n                                justify-content: center;\n                                align-items: center;\n                                flex-shrink: 0;\n                                border-radius: 16px;\n                                background: var(--AA-global-white-bg);\n                                color: var(--AA-gloabl-text-color);\n                                font-size: 12px;\n                                font-weight: 400;\n                                line-height: 16px;\n                            }\n                            a{\n                                overflow: hidden;\n                                color: var(--AA-gloabl-text-desc-color);\n                                text-align: center;\n                                text-overflow: ellipsis;\n                                font-size: 12px;\n                                font-weight: 400;\n                                line-height: 18px;\n                                opacity: 0.8;\n                            }\n                        }\n                    }\n                }\n            }\n            .form-feedback-info{\n                padding: 0;\n                background: transparent;\n                .dialog-ended-and-feedback{\n                    justify-content: flex-end;\n                    .feedback-wrapper {\n                        .feedback-actions-info {\n                            .left-sec-info {\n                                .icon_block{\n                                    display: none;\n                                }\n                                h1{\n                                    display: none;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .less-text{\n            &.hidden{\n                display: none;\n            }\n        }\n        .more-text{\n            &.hidden{\n                display: none;\n            }\n        }\n    }\n}\n","@import './../../../../../scss/search_suggestion';\n\n.assist-suggestions-list{\n    // height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    // overflow: auto;\n    padding: 8px;\n    .sugestions-block{\n        width: 100%;\n        border-radius: 4px;\n        border: 1px solid var(--AA-gloabl-border);\n        background: var(--AA-global-white-bg);\n        .suggestion-body-search{\n            padding-bottom: 8px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
